var _path, _path2, _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.33333C0 2.59695 0.596954 2 1.33333 2H4.70705C5.10378 2 5.4799 2.17667 5.73321 2.482L6.26679 3.12514C6.5201 3.43047 6.89622 3.60714 7.29295 3.60714H14.6667C15.403 3.60714 16 4.2041 16 4.94048V9.66667C16 10.403 15.403 11 14.6667 11H1.33333C0.596953 11 0 10.403 0 9.66667V3.33333Z",
    fill: "url(#paint0_linear_8349_25271)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0666667 3.33333C0.0666667 2.63377 0.633773 2.06667 1.33333 2.06667H4.70705C5.08394 2.06667 5.44126 2.2345 5.68191 2.52457L6.21548 3.16771C6.48145 3.48831 6.87638 3.67381 7.29295 3.67381H14.6667C15.3662 3.67381 15.9333 4.24092 15.9333 4.94048V9.66667C15.9333 10.3662 15.3662 10.9333 14.6667 10.9333H1.33333C0.633772 10.9333 0.0666667 10.3662 0.0666667 9.66667V3.33333Z",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.133333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8349_25271)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 16,
    height: 9,
    rx: 1.33333,
    fill: "url(#paint1_linear_8349_25271)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0666667,
    y: 5.06667,
    width: 15.8667,
    height: 8.86667,
    rx: 1.26667,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.133333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8349_25271",
    x: 0,
    y: 5,
    width: 16,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8349_25271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8349_25271",
    x1: 8,
    y1: 2,
    x2: 8,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C1F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8349_25271",
    x1: 8,
    y1: 5,
    x2: 8,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C1F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.000c6a0facf93c1146456bb9643643f9.svg";
export { ForwardRef as ReactComponent };